import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { HttpRequest } from "@smithy/protocol-http";
export function resolveHostHeaderConfig(input) {
  return input;
}
export var hostHeaderMiddleware = function hostHeaderMiddleware(options) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var request, _ref2, _ref2$handlerProtocol, handlerProtocol, host;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (HttpRequest.isInstance(args.request)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", next(args));
              case 2:
                request = args.request;
                _ref2 = options.requestHandler.metadata || {}, _ref2$handlerProtocol = _ref2.handlerProtocol, handlerProtocol = _ref2$handlerProtocol === void 0 ? "" : _ref2$handlerProtocol;
                if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
                  delete request.headers["host"];
                  request.headers[":authority"] = request.hostname + (request.port ? ":" + request.port : "");
                } else if (!request.headers["host"]) {
                  host = request.hostname;
                  if (request.port != null) host += ":".concat(request.port);
                  request.headers["host"] = host;
                }
                return _context.abrupt("return", next(args));
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
export var hostHeaderMiddlewareOptions = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
export var getHostHeaderPlugin = function getHostHeaderPlugin(options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
    }
  };
};